__turbopack_context__.v({
  "Container": "kR0Txq_Container",
  "HasMultiple": "kR0Txq_HasMultiple",
  "IconWrapper": "kR0Txq_IconWrapper",
  "Image": "kR0Txq_Image",
  "Label": "kR0Txq_Label",
  "LoaderWrapper": "kR0Txq_LoaderWrapper",
  "Root--IndividualHeader": "kR0Txq_Root--IndividualHeader",
  "Root--IndividualTab": "kR0Txq_Root--IndividualTab",
  "Root--Logo": "kR0Txq_Root--Logo",
  "Root--ProfileCardLink": "kR0Txq_Root--ProfileCardLink",
  "Root--Rectangle": "kR0Txq_Root--Rectangle",
  "Root--Square": "kR0Txq_Root--Square",
  "SubHeading": "kR0Txq_SubHeading",
  "Tag": "kR0Txq_Tag",
  "Tags": "kR0Txq_Tags",
  "Text": "kR0Txq_Text",
  "Title": "kR0Txq_Title",
  "WarningText": "kR0Txq_WarningText",
  "skeleton-loading": "kR0Txq_skeleton-loading",
});
